import { useEffect } from 'react'
import { useCustomerContext } from './customerContext'
import { useRouter } from 'next/router'
import {
  ROUTE_BASE_ACCOUNT_HOME,
  ROUTE_BASE_ACCOUNT_LOGIN,
  ROUTE_BASE_EVENTS,
} from '@aether/configs'

export const useAuthRedirect = () => {
  const { isLoggedIn, isVerified, isVip } = useCustomerContext()
  const { push, pathname, query } = useRouter()
  const returnPath = query?.['return_to'] || undefined

  useEffect(() => {
    const isLoginPage = pathname === ROUTE_BASE_ACCOUNT_LOGIN
    const isAccountPage = pathname === ROUTE_BASE_ACCOUNT_HOME

    if (!isVerified) {
      return
    }

    /**
     * User logged In
     */

    // redirect to return path if available
    if (isLoggedIn && isLoginPage && returnPath) {
      // after login, if user is customer and tries to return vip events page, redirect to events page
      if (
        typeof returnPath === 'string' &&
        returnPath.startsWith('/vip/events/') &&
        !isVip
      ) {
        push({ pathname: ROUTE_BASE_EVENTS })
      } else {
        push({ pathname: String(returnPath) })
      }
      return
    }

    // otherwise redirect to account page
    if (isLoggedIn && !isAccountPage) {
      push({ pathname: ROUTE_BASE_ACCOUNT_HOME })
      return
    }

    /**
     * User not logged In
     */

    // redirect to login page
    if (!isLoggedIn && !isLoginPage) {
      push({ pathname: ROUTE_BASE_ACCOUNT_LOGIN })
      return
    }
  }, [push, isLoggedIn, returnPath, pathname, isVerified, isVip])
}
